import classnames from "classnames";
import BreadCrumb from "components/Common/BreadCrumb";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import FeedBartenderList from "./FeedBartenderList";
import FeedBarList from "./FeedBarList";

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const FeedList = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = `${t("Feed")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const [activeFeedTab, setActiveFeedTab] = useState("feed_bar");
  const [searchParams, setSearchParams] = useSearchParams();

  const tabChange = (tab: any) => {
    setSearchParams({});

    if (activeFeedTab !== tab) setActiveFeedTab(tab);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Feed Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="feed_bar"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <div
                  style={{
                    background: "#f3f6f9",
                    borderTopLeftRadius: "0.6rem",
                    borderTopRightRadius: "0.6rem",
                  }}
                >
                  <div
                    className="d-block"
                    style={{
                      background: "#f3f6f9",
                      borderRadius: "0.6rem",
                      width: "fit-content",
                    }}
                  >
                    <Nav tabs className="nav nav-tabs nav-justified">
                      <NavItem>
                        <NavLink
                          style={{
                            cursor: "pointer",
                            background: `${
                              activeFeedTab === "feed_bar"
                                ? "#009ef7"
                                : "unset"
                            }`,
                            color: `${
                              activeFeedTab === "feed_bar"
                                ? "white"
                                : "unset"
                            }`,
                            whiteSpace: "nowrap"
                          }}
                          className={classnames({
                            active_wallpaper:
                              activeFeedTab === "feed_bar",
                          })}
                          onClick={() => {
                            tabChange("feed_bar");
                          }}
                        >
                          {t("Feed Store")}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{
                            cursor: "pointer",
                            background: `${
                              activeFeedTab === "feed_bartender"
                                ? "#009ef7"
                                : "unset"
                            }`,
                            color: `${
                              activeFeedTab === "feed_bartender"
                                ? "white"
                                : "unset"
                            }`,
                            whiteSpace: "nowrap"
                          }}
                          className={classnames({
                            active_wallpaper: activeFeedTab === "feed_bartender",
                          })}
                          onClick={() => {
                            tabChange("feed_bartender");
                          }}
                        >
                          {t("Feed Bartender")}
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </div>

                <TabContent activeTab={activeFeedTab}>
                  <TabPane tabId="feed_bar" className="position-relative">
                    {activeFeedTab === "feed_bar" && (
                      <FeedBarList activeFeedTab={activeFeedTab} />
                    )}
                  </TabPane>

                  <TabPane
                    tabId="feed_bartender"
                    className="position-relative"
                  >
                    {activeFeedTab === "feed_bartender" && (
                      <FeedBartenderList
                        activeFeedTab={activeFeedTab}
                      />
                    )}
                  </TabPane>
                </TabContent>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FeedList;
